import React, { useState } from 'react';
import { View, Text } from 'react-native';

import HeaderDefault from '../../components/HeaderDefault';
import Button from '../../components/Button';
import InputDefault from "../../components/Form/InputDefault";

import styles from './styles';

const RandomKeyPix = () => {
    const [randomKey, setRandomKey] = useState('');

    return (
        <>
            <HeaderDefault title={"Chave aleatória"} />

            <View style={styles.container}>
                <View style={styles.contentInput}>
                    <InputDefault
                        value={randomKey}
                        onValueChange={(value) => setRandomKey(value)}
                        placeholder={"Chave aleatória"}
                    />
                </View>

                <View style={styles.contentPrices}>
                    <Text style={styles.infoPrice}>Valor da transferência:</Text>
                    <Text>XXX,XXX.XXBRL</Text>
                </View>
                <View style={styles.contentPrices}>
                    <Text style={styles.infoPrice}>Moeda:</Text>
                    <Text>GPX Token</Text>
                </View>
                <View style={styles.contentPrices}>
                    <Text style={styles.infoPrice}>Valor do dia:</Text>
                    <Text>XX,XXX.XXGPX</Text>
                </View>
                <View style={styles.contentPrices}>
                    <Text style={styles.infoPrice}>Recebedor:</Text>
                    <Text>Abelardo Bueno da Costa</Text>
                </View>
            </View>

            <Button route={"ConfirmPassword"} text={"CONTINUAR"} titlePage={"Confirmar tranferência"} />
        </>
    );
}

export default RandomKeyPix;